<template>
    <div>
        <vue-headful title="Account Suspended :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active"><i class="fa fa-exclamation-triangle"></i> Account Suspended</li>
            </ol>
        </h4>

        <div v-if="loading">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else class="row">
            <div class="col-xl-9 col-lg-12 mb-3">
                <one-click-login></one-click-login>

                <div class="card mb-3">
                    <div class="card-header">Reason for Suspension:</div>
                    <div class="card-body">
                        <div class="alert alert-warning" v-if="type == 'billing'">
                            <p>{{ message }}</p>

                            <template v-if="this.$store.state.user.is_admin">
                                <router-link to="/billing" class="btn btn-warning">Update Billing</router-link>
                            </template>
                            <ul v-else>
                                <li v-for="user in users">{{ user.FirstName }} {{ user.LastName }} - <a :href="`mailto:${user.email}`">{{ user.email }}</a></li>
                            </ul>
                        </div>
                        <div class="alert alert-warning" v-if="type == 'active'">
                            <p>{{ message }}</p>

                            <template v-if="this.$store.state.user.is_admin">
                                <router-link to="/billing" class="btn btn-warning">Reactivate Account</router-link>
                            </template>
                            <div v-else-if="this.$store.state.user.subcontractor_id && this.sub_contact_email">
                                Subcontractor Admin Contact Email: <a :href="`mailto:${sub_contact_email}`">{{ sub_contact_email }}</a>
                            </div>
                            <ul v-else>
                                <li v-for="user in users">{{ user.FirstName }} {{ user.LastName }} - <a :href="`mailto:${user.email}`">{{ user.email }}</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                type: null,
                message: null,
                sub_contact_email: null,
                users: [],
            }
        },

        methods: {
            //Get the reason for suspension
            getSuspension(){
                //Send it
                this.$http.get('/suspension')
                    .then(res => {
                        this.type = res.data.type;
                        this.message = res.data.message;
                        this.users= res.data.users;
                        this.sub_contact_email = res.data.sub_contact_email;
                    })
                    .then(() => {
                        //Loading
                        this.loading = false;
                    });
            },
        },

        mounted(){
            //Send thi
            this.getSuspension();
        }
    }
</script>
